<template>

  <v-navigation-drawer app clipped :mini-variant="mini">

    <div class="d-flex flex-column justify-space-between fill-height">

      <v-list dense nav>
        <v-tooltip v-for="item in global_list" :key="item.path" right nudge-right="4" :disabled="!mini" color="primary" transition="slide-x-transition">

          <template v-slot:activator="{ on }">
            <v-list-item v-on=on :to="item.path" :exact="item.exact" active-class="primary white--text">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="ml-n4">
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-row no-gutters align="center" style="height: 30px;">
            {{item.title}}
          </v-row>

        </v-tooltip>
      </v-list>

      <v-divider class="mx-2"/>

      <v-list dense nav>
        <v-tooltip v-for="item in local_list" :key="item.path" right nudge-right="4" :disabled="!mini" color="primary" transition="slide-x-transition">

          <template v-slot:activator="{ on }">
            <v-list-item v-on=on :to="item.path" :exact="item.exact" active-class="primary white--text">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="ml-n4">
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-row no-gutters align="center" style="height: 30px;">
            {{item.title}}
          </v-row>

        </v-tooltip>
      </v-list>

      <div style="height: 100%"/>

      <v-divider class="mx-2"/>

      <v-list-group no-action>
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>mdi-cogs</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="ml-n4" style="font-size: smaller">
            Admin
          </v-list-item-content>
        </template>
        <v-list dense nav>
          <v-tooltip v-for="item in admin_list" :key="item.path" right nudge-right="4" :disabled="!mini" color="primary" transition="slide-x-transition">

            <template v-slot:activator="{ on }">
              <v-list-item v-on=on :to="item.path" :exact="item.exact" active-class="primary white--text">
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="ml-n4">
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-row no-gutters align="center">
              {{item.title}}
            </v-row>

          </v-tooltip>
        </v-list>
      </v-list-group>

      <v-divider class="mx-2"/>

      <div class="ma-2">
        <v-btn depressed block class="white" @click.stop="mini=!mini">
          <v-icon class="mx-1" left v-if="!mini">mdi-arrow-collapse-left</v-icon>
          <v-icon class="mx-1" left v-if="mini">mdi-arrow-collapse-right</v-icon>
        </v-btn>
      </div>


    </div>

  </v-navigation-drawer>


</template>


<script>
  export default {
    computed: {

      global_list: function () {
        return [
          {
            title: 'Listă Hoteluri',
            icon: 'mdi-home',
            path: '/hotels',
            exact: true,
            global: true
          },
          {
            title: 'Listă Grupuri',
            icon: 'mdi-home-group',
            path: '/hotel-groups',
            exact: true,
            global: true
          },
          {
            title: 'Listă Rezervări',
            icon: 'mdi-room-service',
            path: '/orders',
            exact: false,
            global: true
          },
          {
            title: 'Listă Furnizori',
            icon: 'mdi-briefcase-account',
            path: '/suppliers',
            exact: false,
            global: true
          },
          {
            title: 'Listă Facturi',
            icon: 'mdi-receipt',
            path: '/invoices',
            exact: false,
            global: true
          },
          {
            title: 'Listă Tranzacții',
            icon: 'mdi-deskphone',
            path: '/transactions',
            exact: false,
            global: true
          }
        ];
      },

      local_list: function () {
        return [
          {
            title: 'Panou Hotel',
            icon: 'mdi-monitor-dashboard',
            path: '/hotels/' + this.$store.state.hotel.id,
            exact: true,
            global: false
          },
          {
            title: 'Camere',
            icon: 'mdi-hotel',
            path: '/hotels/' + this.$store.state.hotel.id + '/rooms',
            exact: false,
            global: false
          },
          {
            title: 'Tarife',
            icon: 'mdi-silverware-fork-knife',
            path: '/hotels/' + this.$store.state.hotel.id + '/rates',
            exact: false,
            global: false
          },
          {
            title: 'Politici de anulare',
            icon: 'mdi-account-cancel',
            path: '/hotels/' + this.$store.state.hotel.id + '/cancellation-policies',
            exact: false,
            global: false
          },
          {
            title: 'Politici de plată',
            icon: 'mdi-account-cash',
            path: '/hotels/' + this.$store.state.hotel.id + '/payment-policies',
            exact: false,
            global: false
          },
          {
            title: 'Contracte',
            icon: 'mdi-seal',
            path: '/hotels/' + this.$store.state.hotel.id + '/contracts',
            exact: false,
            global: false
          },
          {
            title: 'Inventar',
            icon: 'mdi-format-list-text',
            path: '/hotels/' + this.$store.state.hotel.id + '/sheet',
            exact: false,
            global: false
          },
        ]
      },

      admin_list: function () {
        return [
          {
            title: 'Utilizatori',
            icon: 'mdi-account-multiple',
            path: '/admin/users',
            exact: true,
            global: true
          },
          {
            title: 'Roluri',
            icon: 'mdi-account-key',
            path: '/admin/roles',
            exact: true,
            global: true
          }
        ]
      },

    },
    data: () => ({
      mini: false
    })
  }

</script>